export default __webpack_public_path__ + "static/media/howItWorksStep2.46af8e2e.svg";